import React, { useState } from 'react';
import { imagePath } from '@common/services/images-service';

const bgImages = [
  './auth-ocean.webp',
  './auth-sea.webp',
  './auth-sunset.webp',
  './auth-terrain.webp',
  './auth-beach.webp',
  './auth-canyon.webp',
  './auth-forest.webp',
  './auth-sakura.webp',
];

export const LoginBackgrounds = () => {
  const [idx, setIdx] = useState(() =>
    Math.floor(Math.random() * bgImages.length)
  );

  const nextImage = () => {
    setIdx((idx + 1) % bgImages.length);
  };

  return (
    <>
      <img
        className="login-bg"
        src={imagePath(bgImages[idx])}
        onClick={nextImage}
        fetchPriority="high"
        decoding="async"
        alt=""
      />
      <style jsx>{`
        .login-bg {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          /* Match the previous CSS background, which defaulted to
             background-position: 0% 0% (top-left), not object-fit's centered default. */
          object-position: left top;
          cursor: pointer;
        }
      `}</style>
    </>
  );
};
